import { REGISTER_SOCIAL_USER, LOGIN_SOCIAL_USER, IS_LOADING_SOCIAL_LOGIN } from '../actions/types'

const initialRegisterEmailState = {
    emailSocial: '',
    isLoadingSocialViewLogin: true,
    success: '',
    registerSocialUser: {},
    loginSocialUser: '',
    nameSocialUser: '',
    errorType: '',
    tokenUser: '',
    domain: '',
    googleId:''
}

export default function (state = initialRegisterEmailState, action) { //lo que se manda de personasAction en el dispatch es el action
    switch (action.type) { //que me llega la cadena type para el switch y el payload en este caso 
        case IS_LOADING_SOCIAL_LOGIN:
            return { ...state, isLoadingSocialViewLogin: true }
        case REGISTER_SOCIAL_USER:                                          // lo configuramos como la respuesta del servidor, es decir la res desde
            return { ...state, domain: action.payload.registerSocialUser.domain, registerSocialUser: action.payload.registerSocialUser, errorType: action.payload.errorType, tokenUser: action.payload.tokenUser }
        case LOGIN_SOCIAL_USER:
            return { ...state, domain: action.payload.registerSocialUser.domain, loginEmail: action.payload.email, isLoadingViewLoginPassword: false, nameUser: action.payload.name, errorType: action.payload.errorType, googleId:action.payload.googleId }
        default:
            return state
    }
}